import { Get, Post } from "@repo/helpers";
import { keyPair } from "@repo/models";

import { AuditConfig, AuditConfigDefinition, DdlSourceDefinition } from "../models";
import { Settings } from "../models/settings";
import ApiRoute from "./apiRoute";

export default class AuditApi {
	static saveAuditConfig(config: AuditConfig, definition: AuditConfigDefinition) {
		const configuration = {
			EmailRecipients: config.email,
			Enabled: config.active,
			Code: definition.Code,
			Name: config.name,
		};
		config.paramValues.data.forEach((v) => (configuration[v.id] = v.value));
		const configurations = {};
		configurations[config.id || 0] = JSON.stringify(configuration);
		return Post(ApiRoute, "SaveAuditConfigSettings", null, {
			configurations,
		});
	}

	static async loadConfigs(code: string) {
		return await Get<AuditConfig[]>(ApiRoute, "AuditConfigs", { code });
	}

	static async loadDefinition(code: string) {
		return await Get<AuditConfigDefinition>(ApiRoute, "AuditConfigDefinition", {
			code,
		});
	}

	static runAudit(code: string, id?: number) {
		return Post(ApiRoute, "StartAudit", {
			auditorCode: code,
			configId: id,
		});
	}

	static async loadSource(source: string) {
		return await Get<DdlSourceDefinition[]>(source, null).then((d) =>
			d.map((i) => {
				return { id: i.Id, value: i.Name } as keyPair;
			}),
		);
	}

	static async settings() {
		return await Get<Settings>(ApiRoute, "Settings");
	}
}
